import { differenceInSeconds } from 'date-fns';

import { SubmittedAtTime } from 'domains/reporter/Reporter/Fields/types';

export const SUBMIT_TIME_LIMIT = 180; // 3 minutes

export function getCountdownSeconds(
  submittedAt: SubmittedAtTime | null | undefined
): number | null {
  if (submittedAt == null) {
    return null;
  }

  return SUBMIT_TIME_LIMIT - differenceInSeconds(new Date(), new Date(submittedAt));
}
